export const DIMENSIONS = {
  header1: 50,
  header2: 30,
  toolbar: 50,
  status_bar: 20,
  browser_status: 1,
  grouped_row_height: 40,
  cell_height_dense: 28,
  cell_height_compact: 36,
  cell_height_short: 48, //33,
  cell_height_medium: 56,
  cell_height_tall: 88,
  cell_height_extra_tall: 128,
  multiline_expanded_height: 150,
};
